

import { createAsyncThunk } from '@reduxjs/toolkit';
import authServiceApiInstance from '../../../config/apiConfig';


export const createEmail = createAsyncThunk(
  'email/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.post('/emailconfiguration', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create configuration setting');
    }
  }
);
export const fetchAllEmail = createAsyncThunk(
  'email/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.get('/emailconfiguration');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to All Email');
    }
  }
);
export const updateMail = createAsyncThunk(
  'email/update',
  async ({data,Id}: any, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.put(`/emailconfiguration/${Id}`, data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update configuration setting');
    }
  }
);
export const deleteMail = createAsyncThunk(
  'email/delete',
  async (Id: any, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.delete(`/emailconfiguration/${Id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update configuration setting');
    }
  }
);